import React, { useEffect, useState } from 'react'
import Spinwheel from '../../components/common/Spinwheel';
import toast from 'react-hot-toast';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useUserContext } from '../../context/userContext';
import { approveOrRejectApi, getVoucherRemainingAmountApi, getVouchersApi } from '../../utils/ApiEndpointFunctions';
import ReactPaginate from 'react-paginate';
import { useFormik } from 'formik';
import VoucherFilter from '../../components/modal/VoucherFilter';
import ConfirmationModal from '../../components/modal/ConfirmationModal';
import moment from 'moment';
import StatusModal from '../../components/modal/StatusModal';
import { voucherFilterInitialvalues, voucherFilterValidationSchema } from '../../utils/Validation';
import { getLocalizationStatus } from '../../utils/HelperFuncitons';

function Voucher(props) {
  const [vouchers, setVouchers] = useState([])
  const [loading, setLoading] = useState(true)
  const [totalCount, setTotalCount] = useState(null);
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const limit = 10;
  const confirmModalId = "conFirmModalIDVoucher"
  const statusModalId = "statusModalVoucher"
  const voucherFilterModal = "voucherFilterModalId"
  const { userDetails,langPreference } = useUserContext();
  const [selectedVoucher, setSelectedVoucher] = useState({id:null,voucherNo:null});
  const [voucherStatus, setVoucherStatus] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [confirmModalMsg, setConfirmModalMsg] = useState(<>Are you sure you want to <br /> Submit ?</>)
  const [isSubmitvoucher, setIsSubmitvoucher] = useState(false)
  const [okbtn, setOkbtn] = useState("")
  const [submitLoader, setSubmitLoader] = useState(false)
  const [voucherTotals, setVoucherTotals] = useState({ inward: 0, outward: 0 })
  const seniorVoucherAmountRoles = ["admin", "owner"]
  const canViewVoucherAmountSummary = seniorVoucherAmountRoles.includes(userDetails?.roleId?.name?.toLowerCase())

  const formatIndianCurrency = (amount) => {
    return `₹ ${Number(amount || 0).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
  }

  const hasActiveVoucherFilter = () => {
    return Array.from(searchParams.entries()).some(([key, value]) => {
      return !["page", "tab"].includes(key) && Boolean(value)
    })
  }

  const voucherBalance = Number(voucherTotals?.inward || 0) - Number(voucherTotals?.outward || 0)

  const getTimeBeforeNDays = (n) => {
    const currentTime = new Date().getTime();
    return currentTime - n * 24 * 60 * 60 * 1000;
  }



  const getFilterValuesFromUrl = () => {
    const to = searchParams.get("to")
    const from = searchParams.get("from")
    return {
      vendorType: searchParams.get("vendorType") || "",
      name: searchParams.get("name") || "",
      challanNumber: searchParams.get("challanNumber") || "",
      voucherType: searchParams.get("voucherType") || "",
      expenseType: searchParams.get("expenseType") || "",
      dateType: searchParams.get("dateType") || "",
      to: to ? new Date(Number(to)) : "",
      from: from ? new Date(Number(from)) : "",
      status: searchParams.get("status") || "",
    }
  }

  const getFilterQueryFromValues = (values) => {
    const dateType = values?.dateType || ""
    let date = ""
    if (dateType === "3") {
      date = `${values?.to ? new Date(values?.to).getTime() + "-" : ""}${values?.from ? new Date(values?.from).getTime() : ""}`
    } else if (dateType === "2") {
      date = `${getTimeBeforeNDays(30) + "-"}${new Date().getTime()}`
    } else if (dateType === "1") {
      date = `${getTimeBeforeNDays(7) + "-"}${new Date().getTime()}`
    } else if (dateType === "0") {
      date = `${getTimeBeforeNDays(1) + "-"}${new Date().getTime()}`
    }

    return [
      values?.vendorType || "",
      values?.name || "",
      values?.challanNumber || "",
      values?.voucherType || "",
      values?.expenseType || "",
      date,
    ]
  }

  const getVouchers = async (filterReset) => {
    setLoading(true);

    try {
      const filterValues = filterReset === "reset" ? voucherFilterInitialvalues : getFilterValuesFromUrl()
      let filter = getFilterQueryFromValues(filterValues);
      const status= filterReset === "reset" ? "" : filterValues?.status
      const page = searchParams.get("page") || 1
      const res = await getVouchersApi(...filter, limit, page,status);
      if (res.status === 200) {

        setVouchers(res.data?.data?.Voucher);
        setTotalCount(res.data?.data?.totalData);
        setVoucherTotals(res.data?.data?.totals || { inward: 0, outward: 0 });
        setPage(Math.ceil(res.data?.data?.totalData / limit));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const handleFilterVoucher = () => {
    document.getElementById(voucherFilterModal).click()
    const params = new URLSearchParams()
    Object.entries(filterFormik.values).forEach(([key, value]) => {
      if (value) {
        params.set(key, key === "to" || key === "from" ? new Date(value).getTime() : value)
      }
    })
    params.set("page", 1)
    setSearchParams(params)
  }

  const handleResetFilter = () => {
    filterFormik.resetForm()
    setSearchParams({ page: 1 })
  }

  const syncFilterWithUrl = () => {
    const urlValues = getFilterValuesFromUrl()
    const currentValues = filterFormik.values
    const hasChanged = Object.keys(urlValues).some(key => {
      if (key === "to" || key === "from") {
        return new Date(urlValues[key] || "").getTime() !== new Date(currentValues[key] || "").getTime()
      }
      return urlValues[key] !== currentValues[key]
    })
    if (hasChanged) {
      filterFormik.setValues(urlValues)
    }
  }

  const handleVoucherApproval = async (value) => {
    try {
      const res = await approveOrRejectApi({ id: selectedVoucher?.id, status: voucherStatus,reason:value ||"" })
      if (res.status === 200) {
        // toast.success(res.data?.message)
        setConfirmModalMsg(res?.data?.message || `Voucher ${selectedVoucher.voucherNo || ""} is successfully ${voucherStatus}.`)
        document.getElementById(confirmModalId).click()
        document.getElementById("statusModalBtn").click()
        getVouchers()
      }
    } catch (error) {
      console.log(error)
      toast.error(error?.response?.data?.message || "something went wrong");
    }
  }

  const handleConfirmation = (value)=>{
    if(isSubmitvoucher || voucherStatus=="rejected"){
      handleVoucherApproval(value) 
    }else{
      document.getElementById(confirmModalId).click()
    }
  }

  const checkValidation = async (voucher) => {
    try {
      const res = await getVoucherRemainingAmountApi({
        challanOrPONumber: voucher?.challanNumber,
        expenseType: voucher?.expenseType,
        amount: voucher?.amount
      })

      if (res?.status == 200) {
        if (res?.data?.data?.status == 1) {
          setIsSubmitvoucher(true)
        } else {
          setOkbtn("no")
        }
        setConfirmModalMsg(<span className='p-3'>{res?.data?.message}</span>)
      }

      document.getElementById("submitModalBtn1").click()
    } catch (err) {
      console.log(err)
      if (err.response && err.response.data) {
        toast.error(err.response.data.message)
      } else {
        toast.error("Something went wrong")

      }
    }
  }

  const handlePageClick = (event) => {
    let currentPage = event.selected + 1;

    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", currentPage);

    if (newParams.has("tab")) {
      newParams.set("tab", newParams.get("tab"));
    }

    setSearchParams(newParams);
  };

  const filterFormik = useFormik({
    initialValues: voucherFilterInitialvalues,
    validationSchema: voucherFilterValidationSchema(langPreference)
  })

  useEffect(() => {
    syncFilterWithUrl()
    getVouchers()
  }, [searchParams.toString()])

  const customBtnStatusColor =(status)=>{
    if(status.toLowerCase()=="rejected"){
      return {
        color:"black",
        backgroundColor:"#fdc2c2"
      }
    }else{
      return {}
    }
  }
// console.log("conf",confirmModalMsg);


  return (
    <>
      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            <div className="main-content">
              {props.type !== "dashboard" && <div className="dash-nav1">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0 font-blue">{langPreference.voucher || "Voucher"}</h3>
                </div>
              </div>}
              <div className="d-flex justify-content-end align-items-center">
                {userDetails?.roleId?.permission.includes("voucherWrite") && <div><button className="create-order" onClick={() => navigate("/voucher/add")}>{langPreference.add || "Add"}</button></div>}
                <div className="d-flex ms-2">
                  <div className="d-flex align-items-center justify-content-end">
                    <div className="dropdown">
                      <button className="btn btn-dark me-2" type="button" disabled={!Object.values(filterFormik?.values).filter(Boolean).length} onClick={handleResetFilter} >
                        {langPreference.reset_filter || "Reset filter"}
                      </button>
                      <button className="btn filter  dropdown-toggle" type="button" data-bs-toggle="modal" data-bs-target={`#${voucherFilterModal}`}  >
                        <i className="bi bi-funnel me-2"></i>{langPreference.filter || "Filter"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <table className="table d-table mt-4">
                <thead>
                  <tr>
                    <th scope="col">{langPreference.created_date || "Created Date"}</th>
                    <th scope="col">{langPreference.voucher_number || "Voucher number"}</th>
                    <th scope="col">{langPreference.voucher_type || "Vendor type"}</th>
                    <th scope="col">{langPreference.name || "Name"}</th>
                    <th scope="col">{langPreference.challan_po_number  || "Challan/ PO number"}</th>
                    <th scope="col">{langPreference.vendor_type || "Voucher type"}</th>
                    <th scope="col">{langPreference.expenses_type || "Expenses type"}</th>
                    <th scope="col">{langPreference.status || "Status"}</th>
                    <th scope="col">{langPreference.action || "ACTION"}</th>
                  </tr>
                </thead>
                {
                  loading ?
                    <tbody >
                      <tr>
                        <td colSpan={12}>
                          <div className="d-flex justify-content-center">
                            <Spinwheel />
                          </div>
                        </td>
                      </tr>
                    </tbody> :
                    <>
                      <tbody>

                        {vouchers?.length > 0 ? vouchers?.map((ele, index) => {

                          return (
                            <tr key={index}>
                              <td>{ moment(ele?.createdAt).format("DD/MM/YYYY")}</td>
                              <td>{ele?.voucherNumber}</td>
                              <td className='text-capitalize'>{ele?.vendorType}</td>
                              <td>{ele?.name}</td>
                              <td>{ele?.challanNumber ? <Link to={ele?.challanDetails?.length ? `/challan/view/${ele?.challanDetails?.[0]?._id}` : `/purchase/view/${ele?.poDetails?._id}`}>{ele?.challanNumber}</Link> : ""}</td>
                              <td className={ele?.voucherType?.toLowerCase() === "upi" ? "text-uppercase" : "text-capitalize"}>{ele?.voucherType}</td>
                              <td className='text-capitalize'>{ele?.expenseType}</td>
                              <td><button className={`cursor-text text-capitalize ${ele?.status?.toLowerCase() == "approved" ? "approve" : (ele?.status?.toLowerCase() == "rejected" ? "reject" : "sbm")} `} style={customBtnStatusColor(ele?.status)}>{getLocalizationStatus(langPreference,ele?.status)}</button></td>
                              <td>
                                <div>
                                  <div className="dropdown">
                                    <button className="dots dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots-vertical"></i></button>
                                    <ul className="dropdown-menu">
                                      <li className='dropdown-item' onClick={() => { navigate(`/voucher/view/${ele?._id}`) }}>{langPreference.view || "View"}</li>
                                      {userDetails?.roleId?.permission.includes("voucherApprove") && !ele?.isApproveReject  && ele?.status?.toLowerCase() != "approved" &&
                                        <li className='dropdown-item' onClick={(e) => { setOkbtn(""); checkValidation(ele); setSelectedVoucher({id: ele?._id}); setVoucherStatus('approved');setConfirmModalMsg(langPreference?.approve_confirmation || <h1>Are you sure you want to <br/> Approve ?</h1>) }} >{langPreference.approve || "Approve"}</li>}
                                      {userDetails?.roleId?.permission.includes("voucherUpdate") && !ele?.isApproveReject && ele?.status?.toLowerCase() != "approved" &&
                                        <li className='dropdown-item'onClick={() => { navigate(`/voucher/add/${ele?._id}`) }} >{langPreference.edit || "Edit"}</li>}
                                      {userDetails?.roleId?.permission.includes("voucherApproveReject") && !ele?.isReversalVoucher && ele?.status?.toLowerCase() == "approved" &&
                                        <li className='dropdown-item'  data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`}  onClick={(e) => {setSelectedVoucher({id: ele?._id}); setVoucherStatus('rejected');setConfirmModalMsg(langPreference?.confirm_reject || <h1>Are you sure you want to <br/> Reject ?</h1>) }} >{langPreference.reject || "Reject"}</li>}
                                    </ul>
                                  </div>
                                </div>
                              </td>
                            </tr>)
                        }) : <tr className='text-center'>
                          <td colSpan="12">
                            <h1>{langPreference.data_not_found || "Data Not Found"}</h1>
                          </td>
                        </tr>}
                      </tbody></>}
              </table>

            </div>
          </div>

          <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-3">
            {canViewVoucherAmountSummary ? (
              <div className="fw-bold">
                {hasActiveVoucherFilter() ? "Filtered Total" : "Total"}:{" "}
                <span className="text-success">{langPreference?.inward || "Inward"} {formatIndianCurrency(voucherTotals?.inward)}</span>
                <span className="mx-2">|</span>
                <span className="text-danger">{langPreference?.outward || "Outward"} {formatIndianCurrency(voucherTotals?.outward)}</span>
                <span className="mx-2">|</span>
                <span>Balance {formatIndianCurrency(voucherBalance)}</span>
              </div>
            ) : <div></div>}
            {totalCount > limit ? (
              <ReactPaginate
                nextLabel={`${langPreference?.next_page || "Next"}>`}
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={1}
                pageCount={page}
                previousLabel={`< ${langPreference?.previous_page || "Previous"}`}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName={"active"}
                forcePage={searchParams.get('page')? Number(searchParams.get('page'))-1 : 0}
              />
            ) : <div></div>}
            <div></div>
          </div>
        </div>
      </div>
      <VoucherFilter modalId={voucherFilterModal} formik={filterFormik} clickHandler={handleFilterVoucher} />
      <button className='d-none' id="submitModalBtn1" data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} />
      <ConfirmationModal modalId={confirmModalId} handleConfirm={handleConfirmation} message={confirmModalMsg} okbtn={okbtn} reasonRequired={voucherStatus=='rejected'}/>
      <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`} />
      <StatusModal
        modalId={statusModalId}
        message={confirmModalMsg}
      />

    </>
  )
}

export default Voucher
